import React from "react";
import "./footer.css";
function Footer() {
  return <div className="footer">Made With ❤️ By Muhammad Idrees Khan</div>;
}

export default Footer;